import PropTypes from 'prop-types';
import quietTimeScheduleTimePeriodPropType from './quietTimeScheduleTimePeriodPropType';

const quietTimePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  timezone: PropTypes.string,
  createdAt: PropTypes.number,
  quietTimeScheduleTimePeriodList: PropTypes.arrayOf(
    PropTypes.shape(quietTimeScheduleTimePeriodPropType),
  ),
  alertIdList: PropTypes.arrayOf(PropTypes.number),
  // uniqueAlertCount: PropTypes.number,
});

export default { quietTimePropType };
